import {
  ChakraFlex,
  EquipUIFireflyV2Theme,
  FAIconName,
  FireflyIconButton,
  Text,
} from '@equip.health/ui';
import { AnalyticsEvent } from '~/analytics';
import { AISummaryEvents } from '~/analytics/aiSummaryEvents';
import AiBoltIcon from '~/assets/svg/AiBoltIcon';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

type Props = {
  isDisabled?: boolean;
  onRefreshClick?: () => void;
};

export const PatientNoteAiSummaryAwaitingBanner = ({
  onRefreshClick,
  isDisabled,
}: Props) => {
  const { trackEvent } = useAnalytics();

  const sendAnalyticsEvent = (analyticsEvent: AnalyticsEvent) => {
    trackEvent(analyticsEvent, {
      Source: AnalyticsSourceValues.SESSION_GUIDE,
    });
  };
  return (
    <ChakraFlex
      alignItems="center"
      border={`1px dashed ${EquipUIFireflyV2Theme.colors.neutral.line}`}
      borderRadius="12px"
      height="45px"
      justifyContent="space-between"
      marginY="12px"
      padding="12px 10px 12px 16px"
      width="100%"
    >
      <ChakraFlex alignItems="center">
        <AiBoltIcon />
        <Text marginLeft="7px" variant="body">
          An AI summary will be generated and available shortly after your
          session ends.
        </Text>
      </ChakraFlex>

      {/* Show refresh button when legacy props provided */}
      {onRefreshClick && (
        <FireflyIconButton
          ariaLabel="Refresh AI summary"
          icon={FAIconName.redoRegular}
          id="patient-note-ai-summary-awaiting-banner-refresh"
          isDisabled={isDisabled}
          isLoading={isDisabled}
          onClick={() => {
            onRefreshClick();
            sendAnalyticsEvent(AISummaryEvents.aiSummaryRefreshButtonClicked);
          }}
          variant="tertiary"
        />
      )}
    </ChakraFlex>
  );
};
